export default __webpack_public_path__ + "static/V4Mirai-chibi-wallpaper_1440x2560-b6ff0ee0ef0fd8fc8b9d5952712d7078.png";